document.addEventListener("DOMContentLoaded", function(){
  var span = document.getElementById("price")
  if(!span) return;
  var productPrice = Number(document.getElementById("price").innerHTML) / 100
  if(!productPrice) productPrice = 1
  
  function start_checkout_event(button){
    button.addEventListener("click", function(){
      releasit_checkout_conversion(productPrice)
    })
  }

  function add_to_cart_event(form){
    form.addEventListener("submit", function(){
      add_to_cart_conversion(productPrice)
    })
  }
  
  var form_buttons = document.getElementsByClassName("_rsi-buy-now-button")
  Array.from(form_buttons).forEach(button => {
    start_checkout_event(button)
  })

  var cart_form = document.getElementsByClassName("form")
  Array.from(cart_form).forEach((form) => {
    if(form.getAttribute("data-type") == "add-to-cart-form"){
      add_to_cart_event(form)
    }
  })
})